import React from 'react';

import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormHelperText from '@material-ui/core/FormHelperText';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import InfoIcon from '@material-ui/icons/Info';
import ConfirmDialog from './ConfirmDialog';
import { getTerms } from './Terms';


const subscriptionButtonStyle = {
    width: '100%'
};

const buttonIconStyle = {
    paddingRight: 10,
};

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

const deleteButtonStyle = {

};

const helperTextStyle = {
    color: '#c7514c',
};

const containerStyle = {
    // Commenting out visible here makes the title stick to the top and makes button always
    // show, which is nice.
    //overflow: 'visible'
}

let t;

class UpdateCardDialog extends React.Component {
    constructor(props) {
        super(props);
        t = props.t;
        this.state = {
            open: props.open,
            termsChecked: false,
            deleteDialogOpen: false,
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.checked,
        });
    };

    handleClickOpen = () => {
        this.props.toggleDialog();
    };

    handleClose = () => {
        this.props.toggleDialog();
    };

    // Parent dialog.
    onOkClicked = e => {
        e.preventDefault();
        this.props.toggleDialog();
    }
    onDeleteCardClicked = e => {
        e.preventDefault();
        this.setState({
            deleteDialogOpen: true
        });
    }

    // Child (delete) dialog
    onCancelClicked = e => {
        e.preventDefault();
        this.setState({
            deleteDialogOpen: false
        });
    }
    // Child (delete) dialog
    onDeleteClicked = e => {
        e.preventDefault();
        // Todo: implement
        this.setState({
            deleteDialogOpen: false
        });

        this.props.toggleDialog();
        this.props.setLoading(true);
        this.props.deleteCardAndDisableAutomaticRenewal(e);
        window.scrollTo(0, 0)
    }

    onSubscriptionsButtonClicked = e => {
        e.preventDefault();
        this.props.toggleDialog();
        this.props.updatePage('subscription')
        window.scrollTo(0, 0)
    }

    render() {
        const { fullScreen } = this.props;

        /*
         Note that a fix for validateDOMNesting has been done here:

         If this error occurs while using Material UI <Typography> https://material-ui.com/api/typography/,
         then you can easily change the <p> to a <span> by changing the value of the component attribute of the <Typography> element :
         <Typography component={'span'} variant={'body2'}>

         https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
         */
        const deleteDialog =
            <Dialog
                fullScreen={fullScreen}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">

                <DialogTitle id="alert-dialog-title">{t('delete_credit_card_title')}</DialogTitle>

                <DialogContent style={containerStyle}>
                    <DialogContentText component={'span'} id="alert-dialog-description">
                        {t('delete_credit_card_message')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div style={buttonContainerStyle}>
                        <Button
                            style={buttonStyle}
                            variant="text"
                            color="default"
                            onClick={e => this.onDeleteClicked(e)}>
                            {t('delete')}
                        </Button >
                        <Button
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.onCancelClicked(e)}>
                            {t('cancel')}
                        </Button >
                    </div>
                </DialogActions>
            </Dialog>

        const deleteContent =
            <div>
                {t('delete_my_card_information')}
                <br />
                <br />
                <Button
                    autoFocus
                    style={deleteButtonStyle}
                    variant="contained"
                    color="default"
                    onClick={e => this.onDeleteCardClicked(e)}>
                    {t('delete_my_card')}
                </Button >
            </div>

        return (
            <div>
                {this.state.deleteDialogOpen ? deleteDialog : null}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">

                    <DialogTitle id="alert-dialog-title">{t('update_card_information_title')}</DialogTitle>

                    <DialogContent style={containerStyle}>
                        <DialogContentText component={'span'} id="alert-dialog-description">
                            {t('update_card_information_message_1')}
                            <br />
                            <br />
                            {t('update_card_information_message_2')}
                            <br />
                            <br />
                            {t('update_card_information_message_3')}
                            <br />
                            <br />
                            <Button
                                onClick={e => this.onSubscriptionsButtonClicked(e)}
                                style={subscriptionButtonStyle}
                                variant="contained"
                                color="secondary">
                                <InfoIcon style={buttonIconStyle} />
                                {t('go_to_subscriptions')}
                            </Button >
                            <br />
                            <br />
                            {this.props.automaticRenewalWillBeDone ? deleteContent : null}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={e => this.onOkClicked(e)}>
                            {t('ok')}
                        </Button >
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

UpdateCardDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default withMobileDialog()(UpdateCardDialog);


// WEBPACK FOOTER //
// ./src/Components/UpdateCardDialog.js